import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import ProgramSections from './components/ProgramSections';
import PracticeSession from './components/PracticeSession';
import Scoring from './components/Scoring';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <Hero />
        <ProgramSections />
        <PracticeSession />
        <Scoring />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default App;
